import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';

import { regPhone, regEmail, patternPwCker } from "../../utils/utils";
import * as APIS from "../../utils/service";

export default function Findpw({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [inputArr, setinputArr] = useState([]);   
    const [mbemail, setmbemail] = useState('');   
    const [secretnum, setsecretnum] = useState('');   
    const [mbpass, setmbpass] = useState('');   
    const [mbpass2, setmbpass2] = useState('');   

    const [errmsg, seterrmsg] = useState(['', '', '']);   
    const [successmsg, setsuccessmsg] = useState('');   
    const [timerflag, settimerflag] = useState(false);   
    const [secretnumSucc, setsecretnumSucc] = useState(false);   


    const emailidSubmit = () => {

        if(!regEmail.test(mbemail)) {
            seterrmsg(['이메일 형식이 올바르지 않습니다.', '', '']);
            return;
        }
        dispatch(loadingflas({ loading: true }));

        let sender = {
            id: mbemail
        }
        APIS.postData('/v1/login/findpw', sender).then(({ data }) => {
            console.log(data);
            if(data){
                setsuccessmsg(data);
                settimerflag(true);
            }
        }).catch(({ response }) => {
            const { data } = response;
            if(data?.code === 0){
                seterrmsg([data?.msg, '', '']);
            }
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
                
    }
    const secretSubmit = () => {
        if(secretnum === '') {
            seterrmsg(['', '인증번호를 입력해주세요.', '']);
            return;
        }
        dispatch(loadingflas({ loading: true }));

        let sender = {
            id: mbemail,
            certification: secretnum
        }
        APIS.postData('/v1/login/checkCertification', sender).then(({ data }) => {
            console.log(data);
            if(data){
                localStorage.setItem("token", data);
                setsecretnumSucc(true);
            }
        }).catch(({ response }) => {
            const { data } = response;
            if(data?.code === 0){
                seterrmsg(['', data?.msg, '']);
            }
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });        
    }

    const mbpassChange = () => {
        if(mbpass !== mbpass2) {
            seterrmsg(['', '', '비밀번호가 일치하지 않습니다.']);
            return;
        }
        if(!patternPwCker.test(mbpass)) {
            seterrmsg(['', '', '비밀번호 형식이 올바르지 않습니다.']);
            return;
        }

        dispatch(loadingflas({ loading: true }));

        let sender = {
            pw: mbpass,
            authToken: localStorage.getItem('token')
        }
        APIS.postData('/v1/login/pwReset', sender).then(({ data }) => {
            console.log(data);
            if(data){
                
                dispatch(
                    open({
                        component: '비밀번호 변경 완료.',
                        title: '알림',
                        button: "로그인",
                        titleviewer: true,                 
                        alert: false,
                        onPress: () => {
                            dispatch(close());
                            navigate("/Login");
                        },
                    })
                ); 
            }
        }).catch(({ response }) => {
            const { data } = response;
            if(data?.code === 0){
                seterrmsg(['', '', data?.msg]);
            }
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }
    return(
        <Layout header={false}>
            <div className='normalform'>
                <div className='normalform_title'>비밀번호 찾기</div>
                {secretnumSucc === false &&
                <>
                    <div className='inputArea'>
                        <Input 
                            className={`inputs`}
                            placeholder="이메일(ID)"
                            setValue={setmbemail}
                            value={mbemail}
                            name="mb_id"
                            label={'이메일(ID)'}
                            error={errmsg[0]}
                            success={successmsg}
                            errClear={() => {
                                seterrmsg(['', '', '']);
                            }}
                        />                  
                    </div>        
                    {timerflag === false && 
                    <div className='loginbutton'>
                        <Button
                            disabled={mbemail === '' ? true : false}
                            styles={{ marginTop: 40 }}
                            buttonTxt={'인증번호 받기'}
                            onPress={() => {
                                if(mbemail !== ''){
                                    emailidSubmit();
                                }
                            }}
                        />
                    </div>   
                    }


                    {timerflag === true &&
                        <>
                        <div className='inputArea' style={{ marginTop: 40 }}>
                            <Input 
                                className={`inputs`}
                                placeholder="인증번호"
                                setValue={setsecretnum}
                                value={secretnum}
                                name="secretnum"
                                timer={true}
                                timerState={() => {
                                    seterrmsg(['인증시간이 초과됐습니다. 다시 요청해주세요.', '', '']);
                                    settimerflag(false);
                                }}
                                error={errmsg[1]}
                            />                  
                        </div>         
                        <div className='loginbutton'>
                            <Button
                                disabled={secretnum === '' ? true : false}
                                buttonTxt={'확인'}
                                onPress={() => {
                                    if(secretnum !== ''){
                                        secretSubmit();
                                    }
                                }}                                
                            />
                        </div>   
                        </>
                    }
                </>
                }

                {secretnumSucc === true &&
                <>
                <div className='normalform_comment' >비밀번호를 재설정해 주세요.</div>
                <div className='inputArea' style={{ marginTop: 40 }}>
                    <Input 
                        className={`inputs`}
                        type={'password'}
                        placeholder="8~15자리 영문,숫자,특수문자 혼합"
                        setValue={setmbpass}
                        value={mbpass}
                        name="mbpass"
                        label={'비밀번호'}
                        errClear={() => {
                            seterrmsg(['', '', '']);
                        }}                        
                    />                  
                </div>   
                <div className='inputArea' >
                    <Input 
                        className={`inputs`}
                        type={'password'}
                        placeholder="비밀번호 재입력"
                        setValue={setmbpass2}
                        value={mbpass2}
                        name="mbpass"
                        error={errmsg[2]}
                        errClear={() => {
                            seterrmsg(['', '', '']);
                        }}                        
                    />                  
                </div>  
                <div className='loginbutton'>
                    <Button
                        disabled={(mbpass !== '' && mbpass2 !== '') ? false : true}
                        buttonTxt={'확인'}
                        onPress={() => {
                            if(mbpass !== '' && mbpass2 !== ''){
                                mbpassChange();
                            }
                        }}                           
                    />
                </div>
                </>         
                }         
            </div>
        </Layout>
    )
}

